export const PublicRoute = {
    Page404:
        "/404",
    Page500:
        "/500",
    SignIn:
        "/signin",
    Invite:
        "/invite/:id/:secret",
    SignUp:
        "/signup/:code?",
    Activate:
        "/activate",
    ForgotPassword:
        "/forgot-password",
    TransactionView:
        '/view/:id/:ct',
    TransactionViewV2:
        '/v/:id/:transactionEmailId?',
    TransactionViewV3: // ENG-3930, myInvois compatible txn view
        '/t/:hash/:transactionEmailId?',
    TransactionViewV3ShortLink:
        '/l/:hash/:transactionEmailId?',
    MiniPosOrderView:
        '/o/:hash/e-invoice',
    StatementView:
        "/view-statement/:id/:ct",
    StatementViewV2:
        "/s/:statementId/:hash/:emailId?",
    NoPreview:
        '/no-preview',
    NoPreviewIframe:
        '/no-preview-iframe',
    ContactMyinvoisData:
        '/m/:hash',
    PriceAdjustment:
        '/price_transition/:companyId/:hash',
};
